import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import CardSubTitle from "../card/cardSubTitle";

export interface ModalSubtitleProps
  extends React.HTMLAttributes<HTMLDivElement> {}

const ModalSubtitle = forwardRef<HTMLDivElement, ModalSubtitleProps>(
  (props, ref) => {
    const { className, ...rest } = props;
    return (
      <CardSubTitle
        {...rest}
        ref={ref}
        className={twMerge("flex-1", className)}
      />
    );
  }
);

export default ModalSubtitle;
